import AuthBox from 'modules/auth/components/AuthBox'
import ResetPasswordForm from 'modules/auth/components/ResetPasswordForm'

export default function ResetPasswordPage() {
  return (
      <AuthBox title="Cambiar contraseña">
        <ResetPasswordForm/>
      </AuthBox>
  )
}